import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CX_ABSTRACT_SECTION_COMPONENTS } from '@b2b/components/cms/cx-abstract/cx-abstract.tokens';
import { CmsComponentPipe } from '@app/b2b/core/cms/pipes/cms-component.pipe';
import { CmsComponent, CX_COMPONENT } from '@app/core/models/atomics.model';
import { TranslateModule } from '@ngx-translate/core';
import { CxAbstractComponent } from '@b2b/components/cms/cx-abstract/cx-abstract-component/cx-abstract.component';
import { CopyRightComponent } from '@b2b/components/cms/sections/cx-footer-section/copy-right/copy-right.component';

@Component({
  selector: 'cx-footer-section',
  templateUrl: './cx-footer-section.component.html',
  styleUrl: './cx-footer-section.component.scss',
  imports: [CommonModule, RouterModule, TranslateModule, CopyRightComponent, CxAbstractComponent, CmsComponentPipe],
})
export class CxFooterSectionComponent {
  components = inject<CmsComponent[]>(CX_ABSTRACT_SECTION_COMPONENTS);

  CX_COMPONENT = CX_COMPONENT;
}
